// extracted by mini-css-extract-plugin
module.exports = {"logoWrap":"signin_logoWrap__VYVwU","logo":"signin_logo__i3UBi"};